import styled, {css} from "styled-components"
import BaseButton from "../Button/Button"

interface Props {
  active: boolean
}

export const TabContainer = styled.section`
  display: flex;
  ${({theme}) => css`
    margin-bottom: ${theme.spacing.three};
    background-color: ${theme.colors.greys.lightest};
    border: 1px solid ${theme.colors.greys.lightest};  
  `}
`
export const TabButton = styled(BaseButton)<Props>`
  flex: 1;
  border-radius: ${({theme}) => theme.spacing.half};
  border: transparent;
  margin: ${({theme}) => theme.spacing.half};
  ${({theme}) => css`
    color: ${theme.colors.greys.white};
    background-color: ${theme.colors.primary2};
    &:hover, &:focus, &:active {
      background-color: ${theme.colors.primary2};
      color: ${theme.colors.greys.white};
      border: none;
    }
  `}

  ${({theme, active}) => !active && css`
    background-color: transparent;
    color: ${theme.colors.greys.black};
    &:hover, &:focus, &:active {
      background-color: transparent;
      color: ${theme.colors.greys.black};
    }
  `}
`
